import {Component, Inject} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {CompanySearchComponent} from '../../../shared/company-search/company-search.component';
import {MatButtonModule} from '@angular/material/button';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {Company} from '../../interfaces/company.interface';

@Component({
    selector: 'app-opportunity-change-company-dialog',
    template: `
        <h3 mat-dialog-title i18n>Change opportunity client</h3>
        <div mat-dialog-content style="display: flex; flex-direction: column; gap: 15px; min-width: 360px; padding-top: 6px;">
            <span>Select a new client for <strong>{{ opportunity.opportunityName }}</strong></span>
            @if (opportunity.companyName) {
                <div style="font-size: 13px; color: #666;">
                    Current client: <strong>{{ opportunity.companyName }}</strong>
                </div>
            }
            <app-company-search [required]="true"
                [formControl_]="companyControl"
                (companySelection)="selectedCompany = $event"
                (companyValidityChange)="companyValidity = $event"
            ></app-company-search>
        </div>
        <div mat-dialog-actions style="display: flex; justify-content: space-between">
            <button mat-dialog-close mat-flat-button>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="!companyValidity || !selectedCompany" [mat-dialog-close]="selectedCompany">Confirm</button>
        </div>
    `,
    standalone: true,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        CompanySearchComponent,
        ReactiveFormsModule,
        MatDialogActions,
        MatButtonModule,
        MatDialogClose
    ]
})
export class OpportunityChangeCompanyDialogComponent {
    companyControl: FormControl = new FormControl(null);
    selectedCompany: Company | null = null;
    companyValidity = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public opportunity: Opportunity
    ) {}
}
